"use client";

import styled from "styled-components";
import { ChartContainer } from "../ui/chart";

export const BoxContainerChart = styled(ChartContainer)`
  width: 100%;
  max-height: 480px;
  height: 100%;
`;
